import styled from 'styled-components';

export const Root = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
